export const weatherKey = '2b71e2ba536cf52a929c20c5364f7ff6';

export const timeDbKey = '	G1AQ9RIOZUZL';


